import React from 'react';
import HeaderThin from 'app/components/layout/HeaderThin';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import base64 from 'base-64';

import PaymentRequestsTable from 'app/components/payments/PaymentRequestsTable';

import * as paymentRequestActions from 'app/ducks/paymentRequests/actions';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as paymentRequestsSelectors from 'app/ducks/paymentRequests/selectors';

interface IPaymentRequestsListProps {
  match?: any;
  actions?: any;
  paymentRequests?: any;
  appReady?: boolean;
}

interface IPaymentRequestsListState {
  initialFilter: any;
  error?: string;
}

function selector(state) {
  return {
    paymentRequests: paymentRequestsSelectors.getPaymentRequests(state),
    appReady: loadingSelectors.appReady(state),
  };
}

const actionCreators = _.merge(
  paymentRequestActions,
);

@connect(
  selector,
  (dispatch) => ({
    actions: bindActionCreators(actionCreators, dispatch),
  }),
)
export default class PaymentRequestsList extends React.Component<IPaymentRequestsListProps, IPaymentRequestsListState> {
  static defaultProps: IPaymentRequestsListProps = {
    actions: undefined,
    paymentRequests: undefined,
    appReady: false,
    match: false,
  };

  componentDidMount(): void {
    this.props.actions.getAllPaymentRequests();
  }

  render(): React.ReactNode {
    const filterConfig = this.props.match?.params?.filterConfig ? JSON.parse(base64.decode(this.props.match?.params?.filterConfig)) : undefined;

    return (
      <div>
        <div className="row">
          <div className="col">
            <HeaderThin
              title="Payment Requests"
            />
          </div>
        </div>
        <div className="row">
          <div className="col">
            <PaymentRequestsTable
              {...this.props.paymentRequests}
              appReady={this.props.appReady}
              actions={this.props.actions}
              saveFilters
              initialFilterConfig={filterConfig}
              isLoading={this.props.paymentRequests.isLoading}
              selectPaymentRequest={this.props.actions.selectPaymentRequest}
            />
          </div>
        </div>
      </div>
    );
  }
}
